import script from "./MyTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyTable.vue?vue&type=script&setup=true&lang=ts"

import "./MyTable.vue?vue&type=style&index=0&id=739322d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739322d2"]])

export default __exports__